import { gsap } from 'gsap'
$(() => {
    // gsap.from('#ttherobg', {
    //     width: '425%',
    //     height: '425%',
    //     duration: 30,
    // })

    if (document.getElementById('headerH1')) {
        let tl = gsap.timeline({ defaults: { duration: 0.75 } })
        tl.from('.animate1', {
            y: -50,
            stagger: 0.4,
            opacity: 0,
            ease: 'power1.easeInOut',
        }).from('#headerH1', {})
    }
})
